"use client"

import { t } from "@lingui/core/macro";
import Image, { StaticImageData } from 'next/image';
import kexphero from "../../public/kexp-banner-primary-dark-1200x400.webp";
import { useDonorStatus, useUser } from "./dpswr";
import { useContext } from "react";
import { useRouter } from "next/navigation";
import { LocaleContext } from "@/app/[lang]/intlprovider";
import { Link } from "@heroui/react";

export default function MyKEXPCard () {

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const kexpHero: StaticImageData = kexphero;
    const {user, isLoading } = useUser();

    // NOTENOTE: We trigger a donor status transaction here so we can refresh roles
    useDonorStatus()

    const router = useRouter();

    const [locale] = useContext( LocaleContext );

    const userSignedIn = !!user || isLoading;
    const userRole = !user ? t`KEXP LISTENER`
        : user.role === "donor" ? t`KEXP DONOR`
        : user.role === "amplifier" ? t`KEXP AMPLIFIER`
        : t`KEXP LISTENER`;
    const userName = user?.name ?? "";

    if ( !userSignedIn ) {
        router.push( "/" + locale + "/login" );
        return(
            <></>
        );
    }

    return(
        <div className="relative w-full overflow-hidden h-[200px] lg:h-[300px]">
            <Image
                className="object-cover"
                src={kexpHero}
                priority={true}
                fill
                alt={t`Image of KEXP studio`}
                style={{ filter: 'brightness(50%)' }}
            />
            <div className="absolute z-10 bottom-1 w-full">
                <div className="pl-4 sm:pl-32 md:pl-48 lg:pl-72 xl:pl-96">
                    <p className="text-2xl text-ellipsis line-clamp-1 max-[400px]:max-w-[270px] font-semibold text-kexp-light-layout-background mb-1">{userName}</p>
                    <p className="text-sm font-semibold text-kexp-light-layout-background mb-2">{userRole}</p>
                </div>
                <div className="absolute bottom-4 right-2 pr-4 sm:pr-32 md:pr-48 lg:pr-72 xl:pr-96">
                    <Link href={"https://kexp.org"}>
                        <Image
                            src="/kexp-logo-goldwhite-1000x1000.png"
                            alt={t`KEXP Logo`}
                            width={55}
                            height={55}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
}
